export default __webpack_public_path__ + "static/media/shopArea.4c77ba5f.svg";